export const HEADER_OFFSET = {
  offsetHeader: 49,
}

export const PAGE_SIZE = 20
export const SCROLL = { x: 900 }
